import { createNoopInjectionToken } from 'ngxtension/create-injection-token';

export const [injectAppleServicesId, provideAppleServicesId] =
  createNoopInjectionToken<string>('Apple Services Id');
